"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownItemThemes = exports.dropdownItem = exports.dropdownWrapperThemes = exports.dropdownWrapper = exports.dropdownColorThemes = void 0;

var _styledComponents = require("styled-components");

var dropdownColorThemes = ['primary']; // this is the basis for the wrapper and should be void of 'theme' stuff such as application of color

exports.dropdownColorThemes = dropdownColorThemes;
var dropdownWrapper = (0, _styledComponents.css)(["background-color:", ";border-radius:", ";border:", " transparent;box-shadow:", ";font-family:", ";left:0;overflow:hidden;position:absolute;top:", ";width:100%;z-index:", ";"], function (props) {
  return props.theme.c_dropdown_wrapper_primary_background;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.standardButtonBorder;
}, function (props) {
  return props.theme.s_dropdown;
}, function (props) {
  return props.theme.primaryFont;
}, function (props) {
  return props.hasLabel ? '4.6875rem' : '3rem';
}, function (props) {
  return props.theme.dropDown;
}); // apply 'theme' stuff here

exports.dropdownWrapper = dropdownWrapper;
var dropdownWrapperThemes = (0, _styledComponents.css)(["border-color:", ";"], function (props) {
  return props.theme["c_dropdown_wrapper_".concat(props.colorTheme, "_border")];
}); // DROPDOWN ITEM (ROW) STUFFS
// aside from the disabled state, this should be void of 'theme' stuff like application of color

exports.dropdownWrapperThemes = dropdownWrapperThemes;
var dropdownItem = (0, _styledComponents.css)(["display:flex;justify-content:space-between;flex-direction:row;font-size:", ";min-height:2rem;padding:1rem;width:100%;&.c-button-disabled,&:disabled,&.c-button-disabled:hover,&:disabled:hover{&,& *{background-color:", ";color:", ";cursor:not-allowed;font-weight:", "}& svg *{opacity:.5;}border-color:", ";box-shadow:none;}"], function (props) {
  return props.theme.fontMedium;
}, function (props) {
  return props.theme.c_dropdown_button_disabled_background;
}, function (props) {
  return props.theme.c_dropdown_button_disabled_text;
}, function (props) {
  return props.theme.secondaryNormal;
}, function (props) {
  return props.theme.c_dropdown_button_disabled_background;
}); // 'theme' stuff gets applied here

exports.dropdownItem = dropdownItem;
var dropdownItemThemes = (0, _styledComponents.css)(["&,& *{background-color:", ";color:", ";font-family:", ";font-weight:", ";letter-spacing:normal;}", ""], function (props) {
  return props.theme["c_dropdown_button_".concat(props.colorTheme, "_background")];
}, function (props) {
  return props.theme["c_dropdown_button_".concat(props.colorTheme, "_text")];
}, function (props) {
  return props.theme.primaryFont;
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return !props.isAttribution ? (0, _styledComponents.css)(["", ";&.c-button-active:hover,&.c-button-focus,&:hover{&,& *{background-color:", ";color:", ";}}&:active,&.c-button-active{&,& *{background-color:", ";color:", ";}}"], props.forceBorder ? (0, _styledComponents.css)(["border-top:", " ", ";"], props.theme.standardButtonBorder, props.theme["c_dropdown_button_".concat(props.colorTheme, "_hover_background")]) : (0, _styledComponents.css)(["&:not(:first-child){border-top:", " ", ";}"], props.theme.standardButtonBorder, props.theme["c_dropdown_button_".concat(props.colorTheme, "_hover_background")]), props.theme["c_dropdown_button_".concat(props.colorTheme, "_hover_background")], props.theme["c_dropdown_button_".concat(props.colorTheme, "_hover_text")], props.theme["c_dropdown_button_".concat(props.colorTheme, "_active_background")], props.theme["c_dropdown_button_".concat(props.colorTheme, "_active_text")]) : (0, _styledComponents.css)(["&,& *{cursor:default;font-size:", ";font-style:italic;font-weight:", ";padding-bottom:0;padding-top:0;}"], props.theme.fontSmall, props.theme.primaryNormal);
});
exports.dropdownItemThemes = dropdownItemThemes;